import React, { useRef, useState } from "react";
import {
  I2cSignature,
  I2cFileUpload,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { I2cButton } from "@webcomponents/i2cwebcomponents/dist/react";
const generalErrorMessage = "Field is required";
const Signature = ({
  methods,
  field,
  Manual,
  handleValueChanges,
  handleFileUpload,
}) => {
  const SignatureData = useRef(null);
  const [signatureState, setSignatureState] = useState(false);
  // const signEl=document.querySelector('.sign');
  // signEl?.addEventListener('i2c-signature-ready', event => {
  //      console.log('event',event,"are you working heere")
  //    })

  const handleSignatureUpdate = (e) => {
    methods.setValue(
      "sign_off_signature",
      SignatureData.current.getDataURL("JPG"),
    );
    handleValueChanges();
  };
  return (
    <React.Fragment>
      {methods.watch("sign_off_signature") !== "" ?? (
        <>
          <img src={methods.watch("sign_off_signature")} />
        </>
      )}
      <I2cSignature
        ref={SignatureData}
        onI2cSignatureEndStroke={() => handleSignatureUpdate()}
        show-alert
        className="signatureWithoutBottomBar"
      >
        <I2cFileUpload
          {...field}
          autoProcessQueue={false}
          slot="upload"
          no-mobile-controls
          setAcceptedFiles=".png,.jpg,.jpeg"
          label="Click to upload"
          help-text="This is some supporting text to accompany progress bar."
          icon="linear-document-upload"
          ref={Manual}
          max-files={1}
          className="customFileUpload"
          message="SVG, PNG, JPG "
          caption="or drag and drop"
          onI2cAddedFile={(e) => {
            handleValueChanges();
            handleFileUpload();
          }}
          onI2cFileRemoved={(e) => {
            methods.setValue("sign_off_signature", "");
          }}
        ></I2cFileUpload>
      </I2cSignature>
    </React.Fragment>
  );
};
export default Signature;
